const portList = state => state.portList.data
const errorPortList = state => state.errorPortList
const isLoadingPortList = state => state.isLoadingPortList

const availableLines = state => state.availableLines.data
const errorAvailableLines = state => state.errorAvailableLines
const isLoadingAvailableLines = state => state.isLoadingAvailableLines

const dataVesselSchedule = state => state.dataVesselSchedule.data
const errorDataVesselSchedule = state => state.errorDataVesselSchedule
const isLoadingDataVesselSchedule = state => state.isLoadingDataVesselSchedule
const arrDataVesselSchedule = state => state.arrDataVesselSchedule

const requestQuota = state => state.requestQuota.data
const errorRequestQuota = state => state.errorRequestQuota
const isLoadingRequestQuota = state => state.isLoadingRequestQuota

export default {
  portList,
  errorPortList,
  isLoadingPortList,

  availableLines,
  errorAvailableLines,
  isLoadingAvailableLines,

  dataVesselSchedule,
  errorDataVesselSchedule,
  isLoadingDataVesselSchedule,
  arrDataVesselSchedule,

  requestQuota,
  errorRequestQuota,
  isLoadingRequestQuota
}



// WEBPACK FOOTER //
// ./src/store/modules/vessel-schedule/getters.js